module.exports = __webpack_public_path__ + "img/apphome.20e38a90.png";